export default "__VITE_PUBLIC_ASSET__87b766f0__"